import { constant, omit, xor } from 'lodash/fp';

import createReducer from '../utils/createReducer';
import {
  ADD_ENTITY,
  CLEAR_SEARCH,
  RESET_CHALLENGE,
  RESET_PLAYERLIST_FILTERS,
  SEARCH_PLAYERS_LIST,
  SET_PLAYER_TYPE_FILTER,
  TOGGLE_AUTO_ADVANCE_POSITIONS_FILTER,
  TOGGLE_PROJECTED_SCORE_FILTER,
  TOGGLE_PLAYERLIST_GAMES_FILTER,
  TOGGLE_PLAYERLIST_GAMES_STATUS_FILTER,
  TOGGLE_PLAYERLIST_TEAMS_FILTER,
  TOGGLE_PLAYERLIST_SELECTED_TEAMS_FILTER
} from '../constants/actionTypes';

const resetState = {
  filteredGames: [],
  filteredTeams: [],
  selectedTeams: null,
  gameStatusFilters: [],
  playerTypeFilters: [],
  autoAdvancePositions: false,
  showProjectedScore: false
};

const initialState = {
  ...resetState,
  searchTerm: undefined
};

const playerListReducer = createReducer(initialState, {
  [SET_PLAYER_TYPE_FILTER]: (state, action) => ({
    playerTypeFilters: xor(state.playerTypeFilters, [action.value])
  }),

  [TOGGLE_AUTO_ADVANCE_POSITIONS_FILTER]: state => ({
    autoAdvancePositions: !state.autoAdvancePositions
  }),

  [TOGGLE_PROJECTED_SCORE_FILTER]: state => ({
    showProjectedScore: !state.showProjectedScore
  }),

  [TOGGLE_PLAYERLIST_GAMES_FILTER]: (state, action) => ({
    filteredGames: xor(state.filteredGames, [action.gameId])
  }),

  [TOGGLE_PLAYERLIST_GAMES_STATUS_FILTER]: (state, action) => ({
    gameStatusFilters: xor(state.gameStatusFilters, action.statuses)
  }),

  [TOGGLE_PLAYERLIST_TEAMS_FILTER]: (state, action) => ({
    filteredTeams: xor(state.filteredTeams, [action.teamId])
  }),

  [TOGGLE_PLAYERLIST_SELECTED_TEAMS_FILTER]: (state, action) => ({
    selectedTeams: Array.isArray(action.teamId)
      ? action.teamId
      : xor(state.selectedTeams, [action.teamId])
  }),

  [CLEAR_SEARCH]: constant({
    searchTerm: undefined
  }),

  [SEARCH_PLAYERS_LIST]: (state, action) => ({
    searchTerm: action.searchTerm
  }),

  [ADD_ENTITY]: () => ({
    searchTerm: undefined
  }),

  [RESET_PLAYERLIST_FILTERS]: constant(omit('selectedTeams', resetState)),

  [RESET_CHALLENGE]: constant(initialState)
});

export default playerListReducer;
